// extracted by mini-css-extract-plugin
module.exports = {"logo":"Header_logo__vJ1Tx","action":"Header_action__xj4Uv"};